import { CARRIER_LABELS, CARRIER_STYLES } from "../../lib/api";

export function CarrierBadge({ code, className = "" }) {
    const label = CARRIER_LABELS[code] || code;
    const style = CARRIER_STYLES[code] || CARRIER_STYLES.OUTRA;
    return (
        <span
            data-testid={`carrier-badge-${code}`}
            className={`inline-flex items-center px-2.5 py-0.5 border rounded-sm text-[11px] font-bold uppercase tracking-wider ${style} ${className}`}
        >
            {label}
        </span>
    );
}
